// ~/plugins/directus-auth.ts
import {
  createDirectus,
  rest,
  authentication,
  readMe,
  refresh,
  login,
  type AuthenticationStorage,
} from '@directus/sdk';
import type { Schema } from '#shared/types/schema';

export default defineNuxtPlugin(() => {
  const {
    public: { directusUrl },
  } = useRuntimeConfig();

  // Petit storage basé sur les cookies Nuxt, utilisable en SSR et client
  class NuxtCookieStorage {
    // Choisis un nom explicite
    private cookie = useCookie('directus_auth', {
      // sameSite: 'lax',
      // // ⚠️ en "cookie mode" SDK, ce cookie doit être lisible côté client
      // // (donc pas httpOnly) pour hydrater l'état entre SSR et client.
      // secure: process.env.NODE_ENV === 'production',
      // path: '/',
    });

    get() {
      return this.cookie.value;
    }
    set(v: any) {
      this.cookie.value = v;
    }
    delete() {
      this.cookie.value = null;
    }
  }

  const storage = new NuxtCookieStorage() as AuthenticationStorage;

  const directusAuth = createDirectus<Schema>(directusUrl as string)
    .with(authentication('cookie', { autorefresh: true, credentials: 'include', storage }))
    .with(rest({ credentials: 'include', storage }));

  // Helpers pratiques à injecter
  const isAuthenticated = async () => {
    try {
      const me = await directusAuth.request(readMe());
      return me;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const refreshToken = () => directusAuth.request(refresh({ mode: 'cookie' }));

  const logout = () => directusAuth.logout();
  //take email and password as parameters
  const nuxtApp = useNuxtApp();
  const login = async (email: string, password: string = '') => {
    const returnMe = directusAuth.login(email, password);
    nuxtApp.callHook('directus:login');
    console.log('hook directus:login called');
    return returnMe;
  };

  return {
    provide: { directusAuth, isAuthenticated, refreshToken, logout, login, refresh },
  };
});
